import { storage } from 'utils/typedStorage';
import { useEffect } from 'react';
import type { Location } from 'react-router-dom';
import { ROUTE_AFTER_REDIRECT_KEY } from 'utils/bullhornEmbed';
import { paths, toAppUrl, type useAppNavigate } from 'url-registry';

type AppNavigate = ReturnType<typeof useAppNavigate>;

/**
 * Sends the user to the route they were headed for before an auth redirect,
 * once they land back on the home route.
 */
export const useRouteAfterRedirect = (
  location: Location,
  navigate: AppNavigate,
  isAccountReady: boolean
): void => {
  useEffect(() => {
    if (!isAccountReady) return;
    const routeAfterRedirect = storage.getDynamic(ROUTE_AFTER_REDIRECT_KEY);
    if (routeAfterRedirect && location.pathname === paths.HOME) {
      storage.removeDynamic(ROUTE_AFTER_REDIRECT_KEY);
      if (routeAfterRedirect !== paths.HOME) {
        const target = toAppUrl(routeAfterRedirect);
        if (target) {
          navigate(target);
        } else {
          // A route saved by an older build that this one no longer mounts.
          console.warn(
            '[Route] Layout — dropping unregistered routeAfterRedirect:',
            routeAfterRedirect
          );
        }
      }
    }
  }, [isAccountReady, location, navigate]);
};
